export enum ConfirmRedirectActions {
  UPDATE_CONFIRM_REDIRECT_STATE = "UPDATE_CONFIRM_REDIRECT_STATE",
  UPDATE_SHOULD_DISPLAY_PROMPT_STATE = "UPDATE_SHOULD_DISPLAY_PROMPT_STATE",
}